// extracted by mini-css-extract-plugin
module.exports = {"page-body":"page-body__1hqkg","notification-list-page":"notification-list-page__2URKk","notification-list-items":"notification-list-items__2VITe"};